import { useCallback, useState } from "react";
export function useConfirmation(isConfirmingInit = false) {
    const [isConfirming, setIsConfirming] = useState(isConfirmingInit);
    const [resolve, setResolve] = useState();
    const confirm = useCallback(() => {
        setIsConfirming(true);
        return new Promise((_resolve) => {
            setResolve(() => _resolve);
        });
    }, [setResolve, setIsConfirming]);
    const handleConfirmOk = useCallback(() => {
        setIsConfirming(false);
        if (resolve)
            resolve(true);
    }, [resolve, setIsConfirming]);
    const handleConfirmCancel = useCallback(() => {
        setIsConfirming(false);
        if (resolve)
            resolve(false);
    }, [resolve, setIsConfirming]);
    return {
        confirm,
        isConfirming,
        handleConfirmOk,
        handleConfirmCancel,
    };
}
export default useConfirmation;
//# sourceMappingURL=useConfirmation.js.map